// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"5193edc4","791":"057ccf03"}[chunkId] + ".chunk.css";
};